module.exports = __webpack_public_path__ + "media/common/images/article-icon-a312dac7cef6d53083c7a0ee6b120d2b.svg";